import script from "./MentalCheckapply.vue?vue&type=script&setup=true&lang=js"
export * from "./MentalCheckapply.vue?vue&type=script&setup=true&lang=js"

import "./MentalCheckapply.vue?vue&type=style&index=0&id=47d5f323&lang=css"

const __exports__ = script;

export default __exports__